import React from 'react';
import SinglePaymentDisplay from './SinglePaymentDisplay';
import InstallmentPaymentDisplay from './InstallmentPaymentDisplay';
import DirectDebitTotalDisplay from './DirectDebitTotalDisplay';
import SubscriptionPaymentDisplay from './SubscriptionPaymentDisplay';
import { PaymentMethod } from '../../../common/Constants';
import { InstallmentPrice } from '../../../common/ProductMethods';

export type PaymentDisplayManagerProps = {
  paymentMethod: string;
  priceMonthly: InstallmentPrice | undefined;
  priceSingle: number | undefined;
  priceSubscription: number | undefined;
  culture: string;
};

const PaymentDisplayManager = ({
  paymentMethod,
  priceMonthly,
  priceSingle,
  priceSubscription,
  culture
}: PaymentDisplayManagerProps): JSX.Element => {
  const renderHighlightSinglePrice = () => {
    return (
      <>
        {priceSingle && (
          <SinglePaymentDisplay
            style={'p1-bold'}
            text={''}
            priceSingle={priceSingle}
            culture={culture}
          />
        )}

        {priceMonthly && !priceSingle && (
          <DirectDebitTotalDisplay
            style={'p1-bold'}
            priceMonthly={priceMonthly}
            culture={culture}
          />
        )}

        {priceMonthly && (
          <InstallmentPaymentDisplay
            style={''}
            text={''}
            priceMonthly={priceMonthly}
            culture={culture}
          />
        )}
      </>
    );
  };

  const renderHighlightDDPrice = () => {
    return (
      <>
        {priceMonthly && (
          <InstallmentPaymentDisplay
            style={'p1-bold'}
            text={''}
            priceMonthly={priceMonthly}
            culture={culture}
          />
        )}
        {priceMonthly && !priceSingle && (
          <DirectDebitTotalDisplay
            style={'label'}
            priceMonthly={priceMonthly}
            culture={culture}
          />
        )}
        {priceSingle && (
          <SinglePaymentDisplay
            style={!priceMonthly ? 'p1-bold' : 'label'}
            text={!priceMonthly ? '' : 'or '}
            priceSingle={priceSingle}
            culture={culture}
          />
        )}
      </>
    );
  };

  const renderSubscriptionPrice = () => {
    if (!priceSubscription) {
      return <></>;
    }
    const price =
      priceMonthly && priceMonthly.firstInstallmentPrice < priceSubscription
        ? priceMonthly.firstInstallmentPrice
        : priceSubscription;

    return <SubscriptionPaymentDisplay price={price} culture={culture} />;
  };

  switch (paymentMethod) {
    case PaymentMethod.Subscription:
      return renderSubscriptionPrice();
    case PaymentMethod.Single:
      return renderHighlightSinglePrice();
    default:
      return renderHighlightDDPrice();
  }
};

export default PaymentDisplayManager;
